import { render, staticRenderFns } from "./TermTypeSlidebar.vue?vue&type=template&id=132ef9f5"
import script from "./TermTypeSlidebar.vue?vue&type=script&lang=js"
export * from "./TermTypeSlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports